import { render, staticRenderFns } from "./cikis.vue?vue&type=template&id=2b8c9cfa&"
import script from "./cikis.vue?vue&type=script&lang=js&"
export * from "./cikis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cikis.vue"
export default component.exports